export default "/institutions/daycoval.svg";